import { Flex, Select, Stack, Text } from '@chakra-ui/core'
import React from 'react'
import moment from 'moment'

type FiltersProps = {
  setFilters?: React.Dispatch<React.SetStateAction<any>>
}

const Filters: React.FC<FiltersProps> = ({ setFilters }) => {
  React.useEffect(() => {
    if (setFilters) {
      setFilters({
        createdAt: {
          $gte: moment().startOf('month').toDate(),
          $lte: moment().endOf('month').toDate()
        }
      })
    }
  }, [setFilters])
  return (
    <Flex justify="flex-start" mb={4} align="center" w="100%">
      <Stack>
        <Text fontSize="xs" color="gray.500">
          Filter by Time Range
        </Text>
        <Select
          variant="filled"
          fontSize="xs"
          maxW="220px"
          fontWeight="extrabold"
          color="gray.600"
          defaultValue="thisMonth"
          onChange={(e) => {
            const value = e.target.value

            if (setFilters) {
              if (value === 'thisWeek') {
                setFilters({
                  createdAt: {
                    $gte: moment().startOf('week').toDate(),
                    $lte: moment().endOf('week').toDate()
                  }
                })
              } else if (value === 'thisMonth') {
                setFilters({
                  createdAt: {
                    $gte: moment().startOf('month').toDate(),
                    $lte: moment().endOf('month').toDate()
                  }
                })
              } else if (value === 'thisQuarter') {
                setFilters({
                  createdAt: {
                    $gte: moment().startOf('quarter').toDate(),
                    $lte: moment().endOf('quarter').toDate()
                  }
                })
              } else {
                setFilters({})
              }
            }
          }}
        >
          <option value="thisWeek">This Week</option>
          <option value="thisMonth">This Month</option>
          <option value="thisQuarter">This Quarter</option>
          <option value="">All Time</option>
        </Select>
      </Stack>
    </Flex>
  )
}

export default Filters
